import { createFirestoreRepository } from './firestoreRepository'
import { defaultQrGroups, type QrGroup } from './qr'

/**
 * Persists QR groups (each embedding its own `links` array). Backed by
 * Firestore-backed QR groups. This keeps the QR hub, links and section cover
 * images dynamic across devices and admin sessions.
 */
export const qrGroupRepository = createFirestoreRepository<QrGroup>(
  'qrGroups',
  () => defaultQrGroups,
)
